<script>
    
    import { toast } from 'bulma-toast'
    import { fixedpricesStore, fixedpriceStore, modalStore } from '../stores'
    
    import FixedpricesService from '../$services/fixedprices.service.js'
    import DateMethod from '../$methods/date.method.js'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import Button from '../$components/button.svelte'

    let loading = false

    async function deleteFixedprice() {

        loading = true
        const resp = await FixedpricesService.deleteFixedprice($fixedpriceStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        fixedpricesStore.remove($fixedpriceStore._id)
        toast({message: 'Precio fijo eliminado', type: 'is-success'})

        modalStore.close()
    }

    $: statusActive = DateMethod.isAfter($fixedpriceStore.expired)

</script>

<Spinner {loading} />

{#if !loading}
    <DetailsCard
        title="Precio fijo"
        meta={DateMethod.dateTimeLarge($fixedpriceStore.created)}
        statusValue={statusActive ? 'Activo' : 'Expiró'}
    >
        <DetailsFields>
            {#if $fixedpriceStore.admin.name}
                <DetailsField label="Admin" value={$fixedpriceStore.admin.name} />
            {/if}
            <DetailsField label="Proveedor" value={$fixedpriceStore.provider} />
            <DetailsField label="Servicio" value={$fixedpriceStore.service} />
            <DetailsField label="Peso" value={`${$fixedpriceStore.volumetricMin} kg a ${$fixedpriceStore.volumetricMax} kg`} />
            <DetailsField label="Precio" value={$fixedpriceStore.setPrice} />
            {#if $fixedpriceStore.setPrice === 'pricing'}
                <DetailsField label="Precio envío" value={`$${$fixedpriceStore.shipmentPrice}`} mono />
            {/if}
            {#if $fixedpriceStore.setPrice === 'percent'}
                <DetailsField label="IVA" value={`${$fixedpriceStore.iva}%`} />
                <DetailsField label="Porcentaje" value={`${$fixedpriceStore.percent}%`} />
            {/if}
            {#if $fixedpriceStore.setPrice === 'flat'}
                <DetailsField label="Peso referencia" value={ String($fixedpriceStore.weightControl) } />
                <DetailsField label="Precio base" value={ String($fixedpriceStore.shipmentPrice) } />
                <DetailsField label="Costo por kilo" value={ String($fixedpriceStore.weightCost) } />
            {/if}
            <DetailsField label="Cobertura con costo" value={`$${ $fixedpriceStore.coverageCost ?? 0 }`} mono />
            <DetailsField label="Cobertura especial" value={`$${ $fixedpriceStore.coverageSpecial ?? 0 }`} mono />
            <DetailsField label="Expira" value={DateMethod.dateTimeLarge($fixedpriceStore.expired)} />
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <ButtonDelete on:confirm={deleteFixedprice} {loading} />
                    <Button on:click={() => modalStore.set('fixedprice_update_modal')} text="Actualizar" icon="edit" />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}
